var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:("svg_" + _vm.iconName),style:(("height: " + _vm.iconSize + "px; width: " + _vm.iconSize + "px;"))})}
var staticRenderFns = []

export { render, staticRenderFns }